import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "../../component/organisms/header";
import MainLayout from "../../component/atoms/layout/mainLayout";
import Sidebar from "../../component/organisms/sidebar";
import DetailTop from "../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../component/atoms/text/detail/detailPageTitle";
import DetailPageLayout from "../../component/atoms/layout/detail/detailPageLayout";
import GoBack from "../../component/molecules/goBack";
import DetailPageForm from "../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../component/atoms/text/detail/detailFormTitle";
import MainInput from "../../component/atoms/input/mainInput";
import SaveBtn from "../../component/atoms/button/saveBtn";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { toastMsg } from "../../util/toastMsg";
import Radio from "../../component/atoms/input/radio";
import Checkbox from "../../component/atoms/input/checkbox";
import DetailFormText from "../../component/atoms/text/detail/detailFormText";
import { errorHandler } from "../../util/error-handler";
import { nullCheck } from "../../util/check";
import { route } from "../../router/route";
import { regExpression } from "../../util/reg-expresstion";
import PretendardText from "../../component/atoms/text/pretendardText";
import Modal from "../../component/templates/Modal";
import { modalMsg } from "../../util/modalMsg";
import ManagerApi from "../../api/managerApi";

function RootEdit(props) {
  const navigate = useNavigate();
  let { id } = useParams();
  const [pwEdit, setPwEdit] = useState(false);
  const [PwErr, setPwErr] = useState(false);
  const [PwCheckErr, setPwCheckErr] = useState(false);

  const [saveData, setSaveData] = useState({
    name: "",
    email: "",
    password: "",
    passwordCheck: "",
    managerAuthority: "",
    accessMenu: [],
    passwordChangeFlag: false,
  });

  const getData = async () => {
    try {
      const response = await ManagerApi.GetById(id);
      const data = response.data.data;
      setSaveData({
        ...data,
        accessMenu: data.accessMenu ? JSON.parse(data.accessMenu) : [],
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  //비밀번호 체크
  useEffect(() => {
    if (saveData.password !== "" && !regExpression.password.test(saveData.password)) {
      setPwErr(true);
    } else setPwErr(false);
  }, [saveData.password]);

  //비밀번호 확인 체크
  useEffect(() => {
    if (saveData.passwordCheck !== "" && saveData.password !== saveData.passwordCheck) {
      setPwCheckErr(true);
    } else setPwCheckErr(false);
  }, [saveData.passwordCheck]);

  //체크 여부 확인
  const isChecked = (e, route) => {
    if (e.target.checked) {
      saveData.accessMenu.push(route);
    } else {
      saveData.accessMenu = saveData.accessMenu.filter((item) => item !== route);
    }
    setSaveData({ ...saveData });
  };

  //저장하기
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const saveFunc = async () => {
    try {
      const requestDto = {
        email: saveData.email,
        name: saveData.name,
        managerAuthority: saveData.managerAuthority,
        accessMenu: JSON.stringify(saveData.accessMenu),
        password: saveData.password,
        passwordChangeFlag: pwEdit,
      };

      await ManagerApi.Update(id, requestDto);
      toast(toastMsg.update);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage style={{ paddingBottom: "83px", minHeight: "762px" }}>
            <DetailPageTitle>수정하기</DetailPageTitle>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <MainInput
                  type={"text"}
                  placeholder={"이름을 입력해주세요"}
                  value={saveData.name}
                  onChange={(e) => {
                    setSaveData({ ...saveData, name: e.target.value });
                  }}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이메일</DetailFormTitle>
                <DetailFormText>{saveData.email}</DetailFormText>
              </DetailPageForm>
              {pwEdit ? (
                <>
                  <DetailPageForm>
                    <DetailFormTitle>비밀번호</DetailFormTitle>
                    <MainInput
                      type={"password"}
                      placeholder={"새로운 비밀번호를 입력해 주세요."}
                      helperText={"영문/숫자/특수문자 중 2가지 이상 포함, 8자 ~ 16자"}
                      onError={saveData.password?.length >= 0 && PwErr}
                      onChange={(e) => {
                        setSaveData({ ...saveData, password: e.target.value });
                      }}
                    />
                  </DetailPageForm>
                  <DetailPageForm>
                    <DetailFormTitle>비밀번호 재입력</DetailFormTitle>
                    <MainInput
                      type={"password"}
                      placeholder={"새로운 비밀번호를 한 번 더 입력해 주세요."}
                      helperText={"비밀번호가 일치하지 않습니다"}
                      onError={PwCheckErr}
                      onChange={(e) => {
                        setSaveData({ ...saveData, passwordCheck: e.target.value });
                      }}
                    />
                  </DetailPageForm>
                </>
              ) : (
                <DetailPageForm>
                  <DetailFormTitle>비밀번호</DetailFormTitle>
                  <PwEditBtn
                    onClick={() => {
                      setPwEdit(true);
                    }}
                  >
                    비밀번호 변경
                  </PwEditBtn>
                </DetailPageForm>
              )}

              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>관리자 유형</DetailFormTitle>
                <div style={{ display: "flex", gap: "19px" }}>
                  <Radio
                    id={"ROOT"}
                    valueText={"ROOT"}
                    name={"author"}
                    checked={saveData.managerAuthority === "ROOT"}
                    onChange={() => {
                      setSaveData({ ...saveData, managerAuthority: "ROOT" });
                    }}
                  />
                  <Radio
                    id={"ADMIN"}
                    valueText={"ADMIN"}
                    name={"author"}
                    checked={saveData.managerAuthority === "ADMIN"}
                    onChange={() => {
                      setSaveData({ ...saveData, managerAuthority: "ADMIN" });
                    }}
                  />
                </div>
              </DetailPageForm>
              <PretendardText
                style={{
                  color: "#FF4975",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "22.4px",
                  letterSpacing: "-0.408px",
                }}
              >
                *ROOT일 경우 아래 접근권한 설정에 관계없이 모든 메뉴 접근이 가능합니다.
              </PretendardText>
              <DetailPageForm style={{ alignItems: "flex-start", marginBottom: "79px" }}>
                <DetailFormTitle>접근권한</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "22px",
                  }}
                >
                  <div>
                    <CheckboxListTitle>사용자 관리</CheckboxListTitle>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.member_parents)}
                          onChange={(e) => isChecked(e, route.member_parents)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.member_parents) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          보호자회원 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.member_child)}
                          onChange={(e) => isChecked(e, route.member_child)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.member_child) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          자녀회원 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.member_leave)}
                          onChange={(e) => isChecked(e, route.member_leave)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.member_leave) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          탈퇴회원 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                    </div>
                  </div>
                  <div>
                    <CheckboxListTitle>O’s PICK 관리</CheckboxListTitle>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.os_pick)}
                          onChange={(e) => isChecked(e, route.os_pick)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.os_pick) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          O’s PICK 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                    </div>
                  </div>
                  <div>
                    <CheckboxListTitle>학원 관리</CheckboxListTitle>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.academy)}
                          onChange={(e) => isChecked(e, route.academy)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.academy) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          학원 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                    </div>
                  </div>
                  <div>
                    <CheckboxListTitle>서비스 관리</CheckboxListTitle>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px 20px",
                        maxWidth: "418px",
                      }}
                    >
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.service_alarm)}
                          onChange={(e) => isChecked(e, route.service_alarm)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.service_alarm) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          알림 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.service_notice)}
                          onChange={(e) => isChecked(e, route.service_notice)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.service_notice) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          공지사항 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.service_banner)}
                          onChange={(e) => isChecked(e, route.service_banner)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.service_banner) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          배너 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.service_popup)}
                          onChange={(e) => isChecked(e, route.service_popup)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.service_popup) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          팝업 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.service_terms)}
                          onChange={(e) => isChecked(e, route.service_terms)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.service_terms) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          약관 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.service_basic)}
                          onChange={(e) => isChecked(e, route.service_basic)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.service_basic) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          기본 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.service_report)}
                          onChange={(e) => isChecked(e, route.service_report)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.service_report) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          신고 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.service_suggest)}
                          onChange={(e) => isChecked(e, route.service_suggest)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.service_suggest) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          1:1 기능 제안
                        </DetailFormText>
                      </CheckboxWrapper>
                    </div>
                  </div>
                  <div>
                    <CheckboxListTitle>관리자회원 관리</CheckboxListTitle>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <CheckboxWrapper>
                        <Checkbox
                          style={{
                            width: "18px",
                            height: "18px",
                          }}
                          checked={saveData.accessMenu.includes(route.manager)}
                          onChange={(e) => isChecked(e, route.manager)}
                        />
                        <DetailFormText
                          style={{
                            color: saveData.accessMenu.includes(route.manager) ? "#262C31" : "#808991",
                            fontWeight: "500",
                          }}
                        >
                          관리자회원 관리
                        </DetailFormText>
                      </CheckboxWrapper>
                    </div>
                  </div>
                </div>
              </DetailPageForm>
            </div>
            <SaveBtn
              style={{ bottom: "40px", right: "40px" }}
              onClick={() => {
                if (nullCheck(saveData.name)) {
                  setSaveModalOpen(false);
                  return toast("이름을 입력해주세요.");
                }
                if (pwEdit && nullCheck(saveData.password)) {
                  setSaveModalOpen(false);
                  return toast("비밀번호를 입력해주세요");
                }
                if (pwEdit && nullCheck(saveData.passwordCheck)) {
                  setSaveModalOpen(false);
                  return toast("비밀번호를 한번 더 입력해주세요");
                }
                if (pwEdit && PwErr) {
                  setSaveModalOpen(false);
                  return toast("비밀번호를 올바르게 입력해주세요");
                }
                if (PwCheckErr) {
                  setSaveModalOpen(false);
                  return toast("비밀번호가 일치하지 않습니다");
                }
                setSaveModalOpen(true);
              }}
            />
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
      {saveModalOpen ? <Modal title={modalMsg.update?.title} text={modalMsg.update?.content} setModalOpen={setSaveModalOpen} onClick={saveFunc} /> : ""}
    </>
  );
}

export default RootEdit;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PwEditBtn = styled.button.attrs((props) => {})`
  width: 338px;
  height: 48px;
  display: flex;
  padding: 13px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #b8bfc4;
  background-color: transparent;
  color: #808991;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
`;

const CheckboxListTitle = styled(PretendardText).attrs((props) => {})`
  color: #808991;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.039px;
  margin-bottom: 5px;
`;
